export const navigationLinks = [
  {
    text: 'home',
    href: '/',
    partiallyActive: false,
  },
  {
    text: 'about',
    href: '/about',
    partiallyActive: false,
  },
  {
    text: 'services',
    href: '/services',
    partiallyActive: false,
  },
  {
    text: 'contact',
    href: '/contact',
    partiallyActive: false,
  },
  {
    text: 'vehicles',
    href: '/vehicles',
    partiallyActive: false,
  },
];

export const features = [
  {
    title: 'Expert Diagnosis',
    description:
      'Our 3-year industry qualified engineers will thoroughly diagnose the problem with your LGP machinery, ensuring an accurate repair plan.',
  },
  {
    title: 'Transparent Communication',
    description:
      "We'll keep you informed throughout the repair process, explaining the issue and the recommended solution in clear, easy-to-understand terms.",
  },
  {
    title: 'Upfront Quotations',
    description:
      "You'll receive a transparent quote upfront, so you can make informed decisions about your repair.",
  },
  {
    title: 'Genuine Parts',
    description:
      'We use only high-quality, genuine parts to ensure long-lasting repairs and optimal performance for your LGP machinery.',
  },
  {
    title: 'Fast Turnaround Times',
    description:
      "We understand the need to get your equipment back in operation quickly. That's why we prioritize efficient service and strive for fast turnaround times.",
  },
  {
    title: '3-Year Industry Qualified Engineers',
    description:
      'Our team boasts extensive experience and expertise in handling all types of LGP machinery repairs.',
  },
  {
    title: 'Commitment to Quality',
    description:
      'We use only the best parts and equipment to ensure the quality and longevity of our repairs.',
  },
  {
    title: 'Transparent and Honest Service',
    description:
      'We believe in clear communication and upfront pricing, so you can trust us to deliver exceptional service.',
  },
  {
    title: 'Focus on Customer Satisfaction',
    description: 'We go the extra mile to ensure your complete satisfaction with our services.',
  },
];

export const contacts = [
  {
    icon: 'Phone',
    text: '+44 7802 987844',
    link: 'tel:+447802987844',
  },
  {
    icon: 'Mail',
    text: 'support@lgpms.co.uk',
    link: 'mailto:support@lgpms.co.uk',
  },
  {
    icon: 'MapPin',
    text: 'Deeside, United Kingdom',
    link: 'https://www.google.com/maps/place/Deeside,+UK/@53.2026513,-3.0496788,14z/data=!3m1!4b1!4m6!3m5!1s0x487ac4b1583c80e1:0xc5b8c1f5f7760463!8m2!3d53.1997351!4d-3.0329723!16s%2Fm%2F03bx853?entry=ttu&g_ep=EgoyMDI1MDUyOC4wIKXMDSoASAFQAw%3D%3D',
  },
];

export const socials = [
  {
    icon: 'Facebook',
    text: '@lgpms',
    link: 'https://www.facebook.com/people/lgpms-Concepts-Pvt-Ltd/61557543657970/',
  },
  {
    icon: 'Instagram',
    text: '@lgpms',
    link: 'https://www.instagram.com/lgpmsconcepts/',
  },
  {
    icon: 'Linkedin',
    text: '@lgpms',
    link: 'https://instagram.com',
  },
  {
    icon: 'Twitter',
    text: '@lgpms',
    link: 'https://instagram.com',
  },
];
